import { schema } from 'normalizr';

export const socket = new schema.Entity('sockets');

export const socketList = new schema.Array(socket);
